import { render } from "./free.vue?vue&type=template&id=97b939b4&lang=pug"
import script from "./free.vue?vue&type=script&lang=js"
export * from "./free.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__